// extracted by mini-css-extract-plugin
export default {"customMenu":"AdminSidebar_customMenu__QKqWC","adminSidebar":"AdminSidebar_adminSidebar__CScmg","aBtn":"AdminSidebar_aBtn__q4ICa","active":"AdminSidebar_active__Oqhmo"};